import React, {useCallback, useEffect, useRef, useState} from "react";
import { Button, Card, Col, Input, Row, Select } from "antd";
import {
  LeftOutlined,
  SendOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";

import GenerateContentContainer from "./components/GenerateContentContainer";
import OpenAiChatItem from "./components/OpenAiChatItem";

import AppUrl from "../config/appUrl";
import { hasApiCallError, showNotification } from "../utils/commonFunctions";

import "./OpenAi.scss";
import constants from "../utils/constants";
import moment from "moment-timezone";

const { REACT_APP_API_ENDPOINT } = process.env;
const BASE_URL = REACT_APP_API_ENDPOINT;

const OpenAiChat = () => {
  const messageRefs = useRef([]);
  const navigate = useNavigate();

  const [state, setState] = useState({
    message: "",
  });
  const [chatList, setChatList] = useState([]);
  const [messages, setMessages] = useState([]);
  const [aiModel, setAiModel] = useState([]);
  const [modelValue, setModelValue] = useState("gpt-4.1");
  const [sessionId, setSessionId] = useState(null);
  const [generatedTitle, setGeneratedTitle] = useState(null);
  const [selectedChat, setSelectedChat] = useState({});
  const { id } = useParams();
  console.log("------->",id)
  useEffect(() => {
    // setLoading(true);
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
    let apiUrl = `${BASE_URL}/api/v1/history`;
    // if (params.length) apiUrl += `?${params.join("&")}`;

    fetch(apiUrl, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }).then((response) => response.json()) // parse JSON from the response
        .then((data) => {
          if (data?.meta?.success && data) {
            setChatList(data?.data)
          }
        });
    axios.get(`${AppUrl.OPENAI_MODEL_LIST}`).then((response) => {
      setAiModel(response?.data?.data);
    })
  }, [BASE_URL]);

  useEffect(()=>{
    let data = chatList?.find(message => message.session_id === window.location.pathname.split("/").pop());
    if(data){
      selectionHandler(data)
      setSessionId(data?.session_id)
    }
  }, [chatList])

  const selectionHandler = (chat) => {
    window.history.pushState({}, "", `/app/writely-bot/chat-history/${chat?.session_id}`);
    const modifiedChat = {
      ...chat,
      conversation: chat?.conversation.map((o, index)=>{
        return {
          _id: o._id,
          index: index,
          content: o.message,
          timestamp: o.timestamp,
          role: o.role !== "user" ? "assistant" : "user",
          model: o.model,
        }
      })
    }
    setMessages(modifiedChat?.conversation);
    setSessionId(chat?.session_id)
    setSelectedChat(modifiedChat)
  }
  console.log("------",selectedChat?.conversation);

  // Filter chats based on search


  const handleModelSelect = (value) => {
    let getPreviousModelName = aiModel.find(o=>o?.id === (modelValue || "gpt-4.1"))?.name;
    let getNewModelName = aiModel.find(o=>o?.id === (value || "gpt-4.1"))?.name;
    // const mapper = (value) => {
    //   switch (value) {
    //     case "gpt-4.1":
    //       return "gpt-4.1";
    //   }
    // }
    const newMessages = messages;
    newMessages.push({
      role: "custom-model-switch",
      content: `<strong>You’ve switched from <i>${getPreviousModelName}</i> ➡️ <i>${getNewModelName}</i></strong>`,
      model:  "custom-model",
    });
    setModelValue(value);
  }
  const onGoBack = useCallback(() => navigate(-1), [navigate]);


  const sendMessage = async (input) => {
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN)
    console.log("Added", input)
    const response = await fetch(`${AppUrl.OPENAI}/deep_research/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`
      },
      body: JSON.stringify(input),
    });

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");
    // setMessages((prev) => {
    //   const updated = [...prev];
    //   const lastIndex = updated.length - 1;
    //
    //   updated[lastIndex] = {
    //     ...updated[lastIndex],
    //     content: "",
    //   };
    //
    //   return updated;
    // });
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value, { stream: true });
      const lines = chunk.split("\n").filter(line => line.trim() !== "");

      for (const line of lines) {
        if (line === "data: [DONE]") {
          setState((prevState) => ({ ...prevState, loading: false }));
          setMessages((prev) => {
            const updated = [...prev];
            const lastIndex = updated.length - 1;
            updated[lastIndex] = { ...updated[lastIndex], loading: false };
            return updated;
          });
          if(!chatList.find(o=>o.session_id === input.session_id)) {
            let apiUrl = `${BASE_URL}/api/v1/history/${input.session_id}`;
            const getOneHistory = await fetch(apiUrl, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
              }
            });
            const item = await getOneHistory.json();
            if (item?.success && item?.data) {
              setChatList(o=>{
                return [...o, item.data]
              });
              setSelectedChat(item?.data || {})
            }
          }

          return;
        }

        if (line.startsWith("data: ")) {
          try {
            const token = JSON.parse(line.replace("data: ", ""));
            // const token = json;
            setMessages((prev) => {
              const updated = [...prev];
              const lastIndex = updated.length - 1;

              updated[lastIndex] = {
                ...updated[lastIndex],
                content: updated[lastIndex].content + token,
                timestamp: prev.timestamp,
              };

              return updated;
            });

            const lastMessageIndex = messages.length - 1;
            setTimeout(
                () =>
                    messageRefs?.current?.[lastMessageIndex + 1]?.scrollIntoView?.({
                      behavior: "smooth",
                    }),
                100
            );
          } catch(err) {
            console.log(err)
            // skip invalid chunks
          }
        }
      }
    }
  };

  const sendGeminiMessage = async (input) => {
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
    console.log("Added", input);

    // Start loading
    setState((prev) => ({ ...prev, loading: true }));

    const response = await fetch(`${AppUrl.OPENAI}/gemini/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(input),
    });

    if (!response.ok || !response.body) {
      console.error("Gemini stream failed:", response.statusText);
      setState((prev) => ({ ...prev, loading: false }));
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder("utf-8");

    // === Show "typing..." animation before first token ===
    setMessages((prev) => {
      const updated = [...prev];
      const lastIndex = updated.length - 1;
      updated[lastIndex] = {
        ...updated[lastIndex],
        content: "typing",
        loading: true,
        isTyping: true,
      };
      return updated;
    });

    let receivedFirstToken = false;

    const typingInterval = setInterval(() => {
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        if (updated[lastIndex]?.isTyping) {
          const dots =
              updated[lastIndex].content.length >= 10
                  ? "typing"
                  : updated[lastIndex].content + ".";
          updated[lastIndex] = { ...updated[lastIndex], content: dots };
        }
        return updated;
      });
    }, 400);

    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk
            .split("\n")
            .map((l) => l.trim())
            .filter((l) => l !== "");

        for (const line of lines) {
          if (line === "data: [DONE]") {
            clearInterval(typingInterval);
            setState((prev) => ({ ...prev, loading: false }));
            setMessages((prev) => {
              const updated = [...prev];
              const lastIndex = updated.length - 1;
              updated[lastIndex] = {
                ...updated[lastIndex],
                loading: false,
                isTyping: false,
              };
              return updated;
            });
            return;
          }

          if (line.startsWith("data: ")) {
            try {
              const json = JSON.parse(line.replace("data: ", ""));
              const token =
                  typeof json === "string"
                      ? json
                      : json.text || json.delta || json.output || "";

              if (token) {
                if (!receivedFirstToken) {
                  clearInterval(typingInterval);
                  receivedFirstToken = true;

                  setMessages((prev) => {
                    const updated = [...prev];
                    const lastIndex = updated.length - 1;
                    updated[lastIndex].content = "";
                    updated[lastIndex].isTyping = false;
                    return updated;
                  });
                }

                setMessages((prev) => {
                  const updated = [...prev];
                  const lastIndex = updated.length - 1;
                  updated[lastIndex] = {
                    ...updated[lastIndex],
                    content: (updated[lastIndex].content || "") + token,
                  };
                  return updated;
                });
              }
            } catch (err) {
              console.warn("Gemini parse error:", err);
            }
          }
        }
      }
    } catch (err) {
      console.error("Gemini stream error:", err);
    } finally {
      clearInterval(typingInterval);
      setState((prev) => ({ ...prev, loading: false }));
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        updated[lastIndex] = {
          ...updated[lastIndex],
          loading: false,
          isTyping: false,
        };
        return updated;
      });
    }
  };

  const sendAnthropicMessage = async (input) => {
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);

    // === Extract user message safely ===
    const messages = input?.messages || [];
    const lastMessage = messages[messages.length - 1];
    const userText = (lastMessage?.content || input?.message || "").trim();

    console.log("Input:", input);
    console.log("Added:", userText);

    if (!userText) {
      console.error("Anthropic Error: message content cannot be empty");
      return;
    }

    // === Start loading ===
    setState((prev) => ({ ...prev, loading: true }));

    const payload = {
      model: "claude-3-5-sonnet-20240620",
      max_tokens: 1024,
      messages: [{ role: "user", content: userText }],
      session_id: input.session_id || null,
      title: input.title || "Untitled Chat",
    };

    try {
      const response = await fetch(`${AppUrl.OPENAI}/anthropic/chat`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok || !response.body) {
        throw new Error(`Anthropic stream failed: ${response.statusText}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      // === Set initial "typing..." message ===
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        updated[lastIndex] = {
          ...updated[lastIndex],
          content: "typing",
          isTyping: true,
          loading: true,
        };
        return updated;
      });

      let receivedFirstToken = false;

      // === Typing animation ===
      const typingInterval = setInterval(() => {
        setMessages((prev) => {
          const updated = [...prev];
          const lastIndex = updated.length - 1;
          if (updated[lastIndex]?.isTyping) {
            const dots =
                updated[lastIndex].content.length >= 10
                    ? "typing"
                    : updated[lastIndex].content + ".";
            updated[lastIndex] = { ...updated[lastIndex], content: dots };
          }
          return updated;
        });
      }, 400);

      // === Stream data chunks ===
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        const chunk = decoder.decode(value, { stream: true });
        const lines = chunk
            .split("\n")
            .map((l) => l.trim())
            .filter((l) => l !== "");

        for (const line of lines) {
          if (line === "data: [DONE]") {
            console.log("Anthropic stream finished.");
            clearInterval(typingInterval);
            setState((prev) => ({ ...prev, loading: false }));
            setMessages((prev) => {
              const updated = [...prev];
              const lastIndex = updated.length - 1;
              updated[lastIndex] = {
                ...updated[lastIndex],
                isTyping: false,
                loading: false,
              };
              return updated;
            });
            return;
          }

          if (line.startsWith("data: ")) {
            try {
              const json = JSON.parse(line.replace("data: ", ""));
              const token = json.text || "";

              if (token) {
                if (!receivedFirstToken) {
                  receivedFirstToken = true;
                  clearInterval(typingInterval);
                  setMessages((prev) => {
                    const updated = [...prev];
                    const lastIndex = updated.length - 1;
                    updated[lastIndex] = {
                      ...updated[lastIndex],
                      content: "",
                      isTyping: false,
                      loading: true,
                    };
                    return updated;
                  });
                }

                setMessages((prev) => {
                  const updated = [...prev];
                  const lastIndex = updated.length - 1;
                  updated[lastIndex] = {
                    ...updated[lastIndex],
                    content: (updated[lastIndex].content || "") + token,
                  };
                  return updated;
                });
              }
            } catch (err) {
              console.warn("Anthropic parse error:", err);
            }
          }
        }
      }
    } catch (err) {
      console.error("Anthropic stream error:", err);
    } finally {
      // === Always clean up ===
      setState((prev) => ({ ...prev, loading: false }));
      setMessages((prev) => {
        const updated = [...prev];
        const lastIndex = updated.length - 1;
        if (updated[lastIndex]) {
          updated[lastIndex] = {
            ...updated[lastIndex],
            isTyping: false,
            loading: false,
          };
        }
        return updated;
      });
    }
  };

  const onSend = useCallback(async () => {
    const accessToken = localStorage.getItem(constants.ACCESS_TOKEN);
    const message = state.message.trim();

    if (!message) return;

    const response = sessionId ? sessionId : await axios({
      method: "POST",
      url: `${AppUrl.OPENAI}/generateTitle`,
      data: {title: message},
    })
    // console.log("----------", typeof response)
    if(typeof response !== "string" && response?.data?.success){
      setSessionId(response.data.session_id);
      setGeneratedTitle(response.data.title);
      window.history.pushState({}, "", `/app/writely-bot/chat-history/${response?.data?.session_id}`);
    }

    const newMessages = messages;
    newMessages.push({
      role: "user",
      content: message,
      model:  modelValue || "gpt-4.1",
      timestamp: moment.utc().toDate(),
    });
    const payload = {
      messages: [...newMessages].filter(o=>o.model === (modelValue || "gpt-4.1")),
      model: modelValue || "gpt-4.1",
      session_id: sessionId || response?.data?.session_id,
      title: generatedTitle || response.data?.title
    };

    newMessages.push({
      role: "assistant",
      content: "",
      model:  modelValue || "gpt-4.1",
      loading: true,
      timestamp: moment.utc().toDate(),
    });

    setMessages(newMessages);
    setState((prevState) => ({ ...prevState, message: "", loading: true }));

    const lastMessageIndex = messages.length - 1;
    setTimeout(
      () =>
        messageRefs?.current?.[lastMessageIndex]?.scrollIntoView?.({
          behavior: "smooth",
        }),
      100
    );


    //

    const gptModel = {
      "gpt-5": "chatgpt",
      "gpt-4": "chatgpt",
      "gpt-4.1": "chatgpt",
      "gpt-4.1-mini": "chatgpt",
      "gpt-4.1-nano": "chatgpt",
      "o3-deep-research-2025-06-26": "deep_research",
      "gemini-2.5-flash": "gemini",
      "gemini-1.5-pro": "gemini",
      "gemini-2.5-pro": "gemini",
      "gemini-3-pro-preview": "gemini",
      "gemini-3-pro-image-preview": "gemini",
      // "gemini-1.5-flash": "gemini",
      "claude-3-5-sonnet-latest": "anthropic",
      "claude-3-5-sonnet-20241022": "anthropic",
      "claude-3-5-sonnet-20240620": "anthropic",
    }

    console.log("-----", gptModel[modelValue]);
    if (
        gptModel[modelValue] === "deep_research" ||
        gptModel[modelValue] === "chatgpt"
    ) {
      sendMessage(payload);
    } else if (gptModel[modelValue] === "gemini") {
      sendGeminiMessage(payload);
    } else if (gptModel[modelValue] === "anthropic") {
      sendAnthropicMessage(payload);
    } else {
      showNotification("error", "Selected model not integrated")
    }
    //   axios({
    //     method: "POST",
    //     // url: `https://hertz-chatbot.ibism.com/chat/ask_query`,
    //     // data: {
    //     //   "user_id":"session_id_MOnTpGgZgFfEqlby",
    //     //   "query": message
    //     // }
    //     url: `${AppUrl.OPENAI}/chat`,
    //     data: payload,
    //   })
    //       .then((response) => {
    //         const resData = response.data;
    //
    //         if (hasApiCallError(resData?.meta)) {
    //           setMessages((prevMessages) => {
    //             const lastMesssage = prevMessages.pop();
    //             console.log("remove message: ", lastMesssage);
    //
    //             return [...prevMessages];
    //           });
    //         } else {
    //           const newMessage = resData?.data?.content || resData?.response || resData?.data?.response;
    //           let content = newMessage?.content || resData?.response || resData?.data?.response;
    //           while (content.startsWith("\n")) {
    //             content = content.replace("\n", "");
    //           }
    //           newMessage.content = content;
    //           newMessage.model =  modelValue || "gpt-4.1";
    //           setTimeout(
    //               () =>
    //                   messageRefs?.current?.[lastMessageIndex + 1]?.scrollIntoView?.({
    //                     behavior: "smooth",
    //                   }),
    //               100
    //           );
    //
    //           setMessages((prevMessages) => {
    //             prevMessages.pop();
    //
    //             return [...prevMessages, newMessage];
    //           });
    //         }
    //
    //         setState((prevState) => ({ ...prevState, loading: false }));
    //       })
    //       .catch((err) => {
    //         console.log("chat err: ", err);
    //         showNotification("error", "Something went wrong");
    //         setMessages((prevMessages) => {
    //           const lastMesssage = prevMessages.pop();
    //           console.log("remove message: ", lastMesssage);
    //
    //           return [...prevMessages];
    //         });
    //         setState((prevState) => ({ ...prevState, loading: false }));
    //       });
    // }



  }, [messages, state, messageRefs]);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e;

      setState((prevState) => {
        prevState[name] = value;
        return { ...prevState };
      });
    },
    []
  );

  const handleResetChat = () => {
    window.history.pushState({}, "", `/app/writely-bot/chat-history/`);
    setSelectedChat({})
    setMessages([])
    setSessionId(null)

  }

  return (
    <>
          <GenerateContentContainer handleResetChat={handleResetChat} selectedChat={selectedChat} selectionHandler={selectionHandler} list={chatList} containerClassName="open-ai-chat open-ai-cb set-bg set-container" navSideBar={true}>
        
        <Col className="content-container h-full">
          {/* heading start */}
          <Row className="fw" justify="space-between">
            <Col className="title-container w-full mb15">
              <Row className="w-full d-flex-open-ai" align="middle">
                <div className="back-icon mr-3">
                {/*  <LeftOutlined className="text-2xl" onClick={onGoBack} />*/}
                </div>
                <Row align="middle">
                  <span className="icon-round mr-3">
                    <img
                      className=""
                      src="/img/icons/robot-icon.svg"
                      alt="Writely Bot"
                      srcset=""
                    />
                  </span>
                  <Col style={{display: "flex", flex:1, flexDirection:"column"}}>
                  <span>{selectedChat?.title || "Writely Bot"}</span>
                  {selectedChat?.created_at && <span style={{fontSize: 11}}>{selectedChat?.created_at && moment.utc(selectedChat?.created_at).format("DD-MM-YYYY hh:mm:ss A")}</span>}
                  </Col>
                </Row>
                <Row align="flex-end" className="ml-auto mr-5">
                  <Select
                      className="new_select fw"
                      style={{ minWidth: 160}}
                      placeholder="Select Model"
                      // suffixIcon={<CaretDownOutlined style={{ color: "#fff" }} />}
                      clearIcon={
                        <CloseCircleOutlined
                            style={{ color: "#fff", background: "#000", fontSize: 13 }}
                        />
                      }
                      size="large"
                      dropdownMatchSelectWidth={false}
                      value={modelValue || "Gpt4.1 by OpenAI"}
                      onChange={handleModelSelect}
                      // showSearch
                      // allowClear
                  >
                    {aiModel?.map?.((item, i) => (
                        <Select.Option
                            key={item?.id}
                            value={item?.id}
                        >
                          {item?.name}
                        </Select.Option>
                    ))}

                  </Select>

                </Row>
              </Row>
            </Col>
          </Row>
          {/* heading end */}

          {/* chat container start */}
          <Col className="chat-container">
            <Col className="message-list-container h-full">
              {messages && messages?.map((message, i) => (
                  <div key={i} ref={(mRef) => (messageRefs.current[i] = mRef)}>
                    <OpenAiChatItem key={i} message={message} />
                  </div>
              ))}
              {!messages && (
                  <Row className="h-full" align="middle" justify="center">
                    <img
                        className="h-64 w-full"
                        src="/img/empty-ai-chat.svg"
                        alt="Writely Bot"
                        srcset=""
                    />
                  </Row>
              )}

            </Col>
          </Col>

          {/* chat container end */}

          {/* chat input container end */}
          <Card className="chat-input-container">
            <Row align="bottom">
              <Col className="grow">
                <Input.TextArea
                  className="chat-input"
                  value={state.message}
                  placeholder="Type your question or topic of interest here"
                  onChange={handleChange("message")}
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  onPressEnter={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      onSend();
                    }
                  }}
                  disabled={state.loading}
                  size="large"
                />
              </Col>

              <Button
                className="text-2xl"
                type="text"
                onClick={onSend}
                disabled={!state.message.trim()}
                loading={state.loading}
                size="large"
                icon={<SendOutlined className="text-3xl" />}
              />
            </Row>
          </Card>
          {/* chat input container end */}
        </Col>
      </GenerateContentContainer>
    </>
  );
};

export default React.memo(OpenAiChat);
